import React, { useState } from 'react';
import { NavLink, Outlet, Navigate } from 'react-router-dom';
import { BsGrid, BsKey, BsReceipt, BsFileText, BsGlobe, BsDownload, BsPerson, BsList, BsBoxArrowRight, BsKanban, BsClockHistory, BsHeadset, BsBoxSeam } from 'react-icons/bs';
import { CustomerProvider, useCustomer } from './CustomerContext';
import { getCustomerToken } from '../customerAuth';
import './CustomerPortal.css';

const navItems = [
  { to: '/cliente', icon: BsGrid, label: 'Dashboard', end: true },
  { to: '/cliente/proyectos', icon: BsKanban, label: 'Proyectos' },
  { to: '/cliente/bolsas-de-horas', icon: BsClockHistory, label: 'Bolsas de horas' },
  { to: '/cliente/licencias', icon: BsKey, label: 'Licencias' },
  { to: '/cliente/facturas', icon: BsReceipt, label: 'Facturas' },
  { to: '/cliente/presupuestos', icon: BsFileText, label: 'Presupuestos' },
  { to: '/cliente/infraestructura', icon: BsGlobe, label: 'Infraestructura' },
  { to: '/cliente/servicios', icon: BsBoxSeam, label: 'Servicios' },
  { to: '/cliente/descargas', icon: BsDownload, label: 'Descargas' },
  { to: '/cliente/soporte', icon: BsHeadset, label: 'Soporte' },
  { to: '/cliente/perfil', icon: BsPerson, label: 'Perfil' },
];

const PortalInner = () => {
  const { customer, loading, logout, companyLogo, error, refreshData, licenses, services } = useCustomer();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const initial = (customer?.name || customer?.email || '?')[0].toUpperCase();
  // Ocultar secciones sin datos: Licencias/Descargas (SaaS) y Servicios contratados
  const hasLicenses = Array.isArray(licenses) && licenses.length > 0;
  const hasServices = Array.isArray(services) && services.length > 0;
  const items = navItems.filter((it) => {
    if ((it.to === '/cliente/licencias' || it.to === '/cliente/descargas') && !hasLicenses) return false;
    if (it.to === '/cliente/servicios' && !hasServices) return false;
    return true;
  });

  return (
    <div className="customer-portal">
      <div className={`cp-sidebar-overlay${sidebarOpen ? ' open' : ''}`} onClick={() => setSidebarOpen(false)} />
      <aside className={`cp-sidebar${sidebarOpen ? ' open' : ''}`}>
        <div className="cp-sidebar-brand">
          {companyLogo ? <img src={companyLogo} alt="Logo" className="cp-sidebar-logo" /> : <span>Portal Cliente</span>}
        </div>
        <nav className="cp-sidebar-nav">
          {items.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `cp-nav-item${isActive ? ' active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <Icon /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="cp-sidebar-footer">
          <button className="cp-nav-item" onClick={logout}>
            <BsBoxArrowRight /> Cerrar sesion
          </button>
        </div>
      </aside>

      <div className="cp-main">
        <header className="cp-header">
          <button
            className="cp-mobile-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label={sidebarOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={sidebarOpen}
          >
            <BsList aria-hidden="true" />
          </button>
          <div />
          <div className="cp-header-user">
            {!loading && <span className="cp-header-name">{customer?.name || customer?.email || ''}</span>}
            <div className="cp-avatar">{initial}</div>
          </div>
        </header>

        <main className="cp-content">
          {error && (
            <div
              className="cp-alert cp-alert-error"
              role="alert"
              style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}
            >
              <span>{error}</span>
              <button type="button" className="cp-btn cp-btn-outline cp-btn-sm" onClick={refreshData}>Reintentar</button>
            </div>
          )}
          <Outlet />
        </main>
      </div>
    </div>
  );
};

const CustomerPortalLayout = () => {
  if (!getCustomerToken()) return <Navigate to="/cliente/login" replace />;
  return (
    <CustomerProvider>
      <PortalInner />
    </CustomerProvider>
  );
};

export default CustomerPortalLayout;
